/**
 * @module
 */

import {GlobalActor, GlobalContext, globalValue} from '@acng/frontend-relativity';
import {authUser} from '../../core/service/env.js';

/**
 * The current users vip points value
 *
 * `NaN` if the user is not authenticated.
 */
export const ctxVipPoints = GlobalContext(authUser?.points ?? NaN);

/**
 * @returns {(points: number) => void}
 */
export const VipPointsProvider = () => {
  const provide = GlobalActor(ctxVipPoints);

  return (points) => {
    if (points != globalValue(ctxVipPoints)) {
      provide(points ?? NaN);
    }
  };
};
